import { Environment } from "../app/interfaces";

export const environment: Environment = {
  apiUrls: {
    calculation: "https://uat-acorn-apim-api.azure-api.net/calculation/api/",
    customer: 'https://uat-acorn-apim-api.azure-api.net/acorn/api/',
    subscriptionKey: '6cd5bbdc89cc44888fa52f477cbe889f',
  }
};
